import { h } from 'preact';
import PropTypes from 'prop-types';

import Overlay from '../../2-atoms/overlay/overlay';

const OverlayWrapper = ({ children, showOverlay }) =>
  showOverlay && (
    <div className="l-wrapper l-wrapper--transparent c-overlay-wrapper">
      <Overlay />
      {children}
    </div>
  );

OverlayWrapper.propTypes = {
  children: PropTypes.any,
  showOverlay: PropTypes.bool,
};

export default OverlayWrapper;
